import React from 'react';

export default (props) => {
  let columnClass = '';
  if (props.small) {
    columnClass += ' small-' + props.small;
  }
  if (props.medium) {
    columnClass += ' medium-' + props.medium;
  }
  if (props.large) {
    columnClass += ' large-' + props.large;
  }
  if (props.width) {
    columnClass = 'large-' + props.width;
  }
  if (props.className) {
    columnClass += ' ' + props.className;
  }
  columnClass += ' columns';
  columnClass = columnClass.trim();
  if(props.end) {
    columnClass += ' end';
  }
  return (
    <div className={columnClass}>
      {props.children}
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./components/column.js
 **/